import { useStore } from "@/stores/useStore";
import { useMemo } from "react";
import { ShopConfig } from "@/types/v2";
import {
  DEFAULT_DASHBOARD_SCALING,
  DEFAULT_WORKING_HOURS,
  DEFAULT_INBOX_PANEL_CONFIG,
} from "@/lib/const";

export const useShopConfig = () => {
  const shop = useStore((s) => s.shop);
  return useMemo<ShopConfig>(
    () =>
      shop?.shopConfig ?? {
        dashboardScaling: DEFAULT_DASHBOARD_SCALING,
        terminology: undefined,
        useShopHeroEmployeeJobTitle: false,
        workingHours: DEFAULT_WORKING_HOURS,
        inboxPanel: DEFAULT_INBOX_PANEL_CONFIG,
      },
    [shop?.shopConfig]
  );
};
